import { cn } from '@/utils/cn-tw-merge';

interface SearchSectionBoxButtonsProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const SearchSectionBoxButtons = ({ children, className, ...props }: SearchSectionBoxButtonsProps) => {
  return (
    <div className={cn('bg-green-600/70 w-full rounded-t-3xl', className)} {...props}>
      {children}
    </div>
  );
};
